<script setup>
import AiApplyHelperWizard from './wizard/AiApplyHelperWizard.vue';
import useModalAuth from './composables/useModalAuth';
import DsSmallTip from 'JIX/components/ds/DsSmallTip.vue';
import T from './JobText.i18n';
import { aiApplyHelperAnalytics } from './analytics';

defineProps({
    humanjobid: {
        type: Number,
        required: false,
        default: null,
    },
});

const { showModal, mountModal, handleStartWizard } = useModalAuth();

function handleStartWizardWithAnalytics() {
    handleStartWizard();
    aiApplyHelperAnalytics.jobtext_start();
}

</script>

<template>
    <AiApplyHelperWizard
        v-if="mountModal"
        v-model:showModal="showModal"
        :humanjobid="humanjobid"
    />
    <DsSmallTip
        class="mt-4"
        :heading-tag="T.bannerHeadingTag()"
        :heading="T.bannerHeading()"
    >
        <p>
            {{ T.bannerParagraph() }}
        </p>
        <button class="btn btn-link mt-3" @click.prevent="handleStartWizardWithAnalytics">
            {{ T.bannerLink() }}
        </button>
    </DsSmallTip>
</template>
